import React from "react";
import "./BookRide.css";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const BookRide = () => {
  const routes = [
    {
      name: "Chh. Sambhajinagar to Mumbai",
      type: "Premium Taxi",
      distance: "340 km",
      features: ["AC Cab", "Free Cancellation", "24/7 Support"],
    },
    {
      name: "Chh. Sambhajinagar to Pune",
      type: "Luxury Sedan",
      distance: "260 km",
      features: ["WiFi", "Charging Ports", "Professional Driver"],
    },
    {
      name: "Chh. Sambhajinagar to Nashik",
      type: "SUV Service",
      distance: "220 km",
      features: ["Spacious", "Child Seats Available", "Pets Allowed"],
    },
    {
      name: "Chh. Sambhajinagar to Surat",
      type: "Outstation Taxi",
      distance: "480 km",
      features: ["Round Trip Options", "Night Drive", "Multiple Stops"],
    },
    {
      name: "Chh. Sambhajinagar to Shirdi",
      type: "Pilgrimage Cab",
      distance: "130 km",
      features: ["Temple Visits", "Luggage Space", "Quick Booking"],
    },
    {
      name: "Chh. Sambhajinagar to Ellora",
      type: "Local Tour Cab",
      distance: "30 km",
      features: ["Guided Tour", "Hourly Packages", "Multilingual Driver"],
    },
    {
      name: "Chh. Sambhajinagar to Ajanta",
      type: "Heritage Cab",
      distance: "110 km",
      features: ["Expert Guide", "Flexible Timings", "Photo Stops"],
    },
    {
      name: "Chh. Sambhajinagar to Nanded",
      type: "Gurudwara Taxi",
      distance: "270 km",
      features: [
        "Clean Vehicles",
        "Respectful Drivers",
        "Punjabi Speaking Staff",
      ],
    },
    {
      name: "Chh. Sambhajinagar to Kalyan",
      type: "Express Cab",
      distance: "320 km",
      features: ["Fastest Route", "Toll Included", "Direct Service"],
    },
    {
      name: "Chh. Sambhajinagar to Kolhapur",
      type: "Family Cab",
      distance: "370 km",
      features: ["7-Seater", "Entertainment", "Comfort Stops"],
    },
    {
      name: "Chh. Sambhajinagar to Nagpur",
      type: "Business Class",
      distance: "470 km",
      features: ["Executive Cars", "Work-Friendly", "Priority Service"],
    },
    {
      name: "Chh. Sambhajinagar to Grishneshwar",
      type: "Temple Taxi",
      distance: "35 km",
      features: ["Early Morning Service", "Pooja Materials", "Clean Footwear"],
    },
    {
      name: "Chh. Sambhajinagar to Jalgaon",
      type: "Economy Cab",
      distance: "140 km",
      features: ["Budget Friendly", "Reliable", "No Hidden Charges"],
    },
    {
      name: "Chh. Sambhajinagar to Parli Vaijnath",
      type: "Devotee Special",
      distance: "180 km",
      features: ["Prasad Transport", "Bhajan System", "Veg Only"],
    },
    {
      name: "Chh. Sambhajinagar to Pandharpur",
      type: "Warkari Taxi",
      distance: "290 km",
      features: ["Palkhi Special", "Traditional Decor", "Spiritual Guides"],
    },
    {
      name: "Chh. Sambhajinagar to Ahmednagar",
      type: "Shared Cab",
      distance: "120 km",
      features: ["Cost Effective", "Meet Locals", "Frequent Departures"],
    },
    {
      name: "Chh. Sambhajinagar to Pune Airport",
      type: "Airport Transfer",
      distance: "250 km",
      features: ["Flight Tracking", "Meet & Greet", "Luggage Help"],
    },
    {
      name: "Jyotirlinga Tour Package",
      type: "Premium Tour",
      distance: "Multi-city",
      features: ["12 Temples", "Luxury Stay", "Meals Included"],
    },
    {
      name: "Chh. Sambhajinagar to Goa",
      type: "Beach Getaway Cab",
      distance: "650 km",
      features: ["Multi-day Trip", "Cooler Included", "Beach Gear"],
    },
    {
      name: "Chh. Sambhajinagar to Hyderabad",
      type: "Executive Travel",
      distance: "520 km",
      features: ["Leather Seats", "Refreshments", "Convoy Option"],
    },
    {
      name: "Chh. Sambhajinagar to Indore",
      type: "Business Express",
      distance: "330 km",
      features: ["Workstation Setup", "Meeting Ready", "High Priority"],
    },
    {
      name: "Chh. Sambhajinagar to Aurangabad Airport",
      type: "Quick Connect",
      distance: "12 km",
      features: ["15-min Pickup", "Baggage Handling", "Flight Alerts"],
    },
    {
      name: "Chh. Sambhajinagar to Lonavala",
      type: "Hill Station Special",
      distance: "280 km",
      features: ["Scenic Route", "Photo Breaks", "Monsoon Ready"],
    },
    {
      name: "Chh. Sambhajinagar to Bhopal",
      type: "Capital City Cab",
      distance: "440 km",
      features: ["Government Approved", "Security Cleared", "Document Storage"],
    },
    {
      name: "Chh. Sambhajinagar to Dhule",
      type: "Semi-Urban Connect",
      distance: "160 km",
      features: ["Agricultural Route", "Market Stops", "Cargo Space"],
    },
    {
      name: "Chh. Sambhajinagar to Ratnagiri",
      type: "Coastal Cruiser",
      distance: "420 km",
      features: ["Seafood Transport", "Beach Towels", "Sunroof Option"],
    },
    {
      name: "Chh. Sambhajinagar to Solapur",
      type: "Textile Hub Taxi",
      distance: "240 km",
      features: ["Parcel Service", "Business Class", "Sample Transport"],
    },
    {
      name: "Chh. Sambhajinagar to Wardha",
      type: "Gandhi Tour Cab",
      distance: "210 km",
      features: ["Heritage Guide", "Library Access", "Khadi Friendly"],
    },
    {
      name: "Chh. Sambhajinagar to Amravati",
      type: "University Special",
      distance: "190 km",
      features: ["Student Discount", "Book Storage", "Study Lights"],
    },
    {
      name: "Chh. Sambhajinagar to Nashik Airport",
      type: "Air Express",
      distance: "200 km",
      features: ["Pre-security Check", "Boarding Pass Print", "Priority Lane"],
    },
    {
      name: "Chh. Sambhajinagar to Chalisgaon",
      type: "Market Day Taxi",
      distance: "90 km",
      features: ["Early Departure", "Goods Transport", "Local Knowledge"],
    },
    {
      name: "Chh. Sambhajinagar to Trimbakeshwar",
      type: "Spiritual Quick Trip",
      distance: "230 km",
      features: ["Ritual Assistance", "Holy Water Carrier", "Pandit Connect"],
    },
    {
      name: "Chh. Sambhajinagar to Mumbai Cruise Terminal",
      type: "Luxury Transfer",
      distance: "345 km",
      features: ["Port Entry", "Luggage Wrap", "VIP Clearance"],
    },
    {
      name: "Deccan Odyssey Tour",
      type: "Heritage Luxury",
      distance: "Multi-state",
      features: ["5-Star Service", "Historic Sites", "Butler Attached"],
    },
    {
      name: "Chh. Sambhajinagar to Mahabaleshwar",
      type: "Hill Station Deluxe",
      distance: "320 km",
      features: [
        "Panoramic Views",
        "Strawberry Farm Visits",
        "Honeymoon Package",
      ],
    },
    {
      name: "Chh. Sambhajinagar to Matheran",
      type: "Eco-Friendly Cab",
      distance: "290 km",
      features: ["No-Pollution Zone", "Toy Train Transfer", "Pet-Friendly"],
    },
    {
      name: "Chh. Sambhajinagar to Bhandardara",
      type: "Lakeside Retreat",
      distance: "180 km",
      features: ["Camping Gear", "Boating Booking", "Stargazing Stops"],
    },
    {
      name: "Chh. Sambhajinagar to Tuljapur (Bhavani Temple)",
      type: "Goddess Special",
      distance: "160 km",
      features: ["Prasad Courier", "Aarti Timings", "Temple VIP Entry"],
    },
    {
      name: "Chh. Sambhajinagar to Akkalkot (Swami Samarth)",
      type: "Saint Express",
      distance: "220 km",
      features: [
        "Darshan Fast Track",
        "Marathi Speaking Driver",
        "Holy Water Carrier",
      ],
    },
    {
      name: "Chh. Sambhajinagar to Shegaon (Gajanan Maharaj)",
      type: "Overnight Bhakti Cab",
      distance: "300 km",
      features: ["Sleeping Pods", "Devotional Music", "Free Temple Meals"],
    },
    {
      name: "Chh. Sambhajinagar to Nagpur (IT Park)",
      type: "Tech Executive",
      distance: "470 km",
      features: ["WiFi Hotspot", "Conference Call Setup", "Ergonomic Seats"],
    },
    {
      name: "Chh. Sambhajinagar to Pune (Hinjewadi)",
      type: "IT Zone Shuttle",
      distance: "255 km",
      features: ["Multiple Stops", "Laptop Charging", "Early Morning Shift"],
    },
    {
      name: "Chh. Sambhajinagar to Mumbai (BKC)",
      type: "Corporate Limo",
      distance: "340 km",
      features: [
        "Meeting Prep Kit",
        "Newspaper/Magazines",
        "Secretarial Support",
      ],
    },
    {
      name: "Chh. Sambhajinagar to Tadoba Jungle Safari",
      type: "Wildlife Explorer",
      distance: "380 km",
      features: ["Gypsy Booking", "Binoculars Provided", "Naturalist Guide"],
    },
    {
      name: "Chh. Sambhajinagar to Harishchandragad Trek",
      type: "Adventure Van",
      distance: "130 km",
      features: ["Trekking Gear", "Camping Setup", "First-Aid Trained Driver"],
    },
    {
      name: "Chh. Sambhajinagar to Ganpatipule (Beach Trek)",
      type: "Coastal Adventurer",
      distance: "450 km",
      features: [
        "Surfboard Carrier",
        "Bonfire Arrangement",
        "Dolphin Spotting",
      ],
    },
    {
      name: "Chh. Sambhajinagar to Lavasa",
      type: "European Style Getaway",
      distance: "270 km",
      features: [
        "Yacht Booking",
        "Private Chef Option",
        "Instagram Photoshoot",
      ],
    },
    {
      name: "Chh. Sambhajinagar to Aamby Valley",
      type: "VIP Resort Transfer",
      distance: "250 km",
      features: ["Golf Club Access", "Helipad Drop", "Butler Service"],
    },
    {
      name: "Wine Tour (Nashik Vineyards)",
      type: "Premium Sommelier Cab",
      distance: "200 km",
      features: [
        "Tasting Sessions",
        "Grape Harvest Experience",
        "Designated Driver",
      ],
    },
    {
      name: "Chh. Sambhajinagar to Bengaluru (Tech Corridor)",
      type: "Interstate Elite",
      distance: "750 km",
      features: [
        "Overnight Sleeper",
        "Biometric Security",
        "Multi-Lingual Driver",
      ],
    },
    {
      name: "Chh. Sambhajinagar to Indore (Sarafa Bazaar)",
      type: "Foodie Night Ride",
      distance: "330 km",
      features: ["Late Night Departure", "Local Guide", "Cooler for Sweets"],
    },
    {
      name: "Golden Triangle (Aurangabad-Mumbai-Goa)",
      type: "Luxury Road Trip",
      distance: "1000+ km",
      features: ["3-Day Package", "Beach+City Combo", "Personal Videographer"],
    },
    {
      name: "Bollywood Studio Tour (Mumbai)",
      type: "Celebrity Style Cab",
      distance: "340 km",
      features: ["Backstage Pass", "Actor Transport History", "Makeup Van"],
    },
    {
      name: "Ajanta-Ellora Photography Tour",
      type: "Artist Special",
      distance: "110 km",
      features: ["Tripod Mounts", "Golden Hour Stops", "Drone Permit Help"],
    },
    {
      name: "Textile Trail (Bhiwandi-Malegaon)",
      type: "Fabric Connoisseur",
      distance: "Multi-City",
      features: ["Sample Swatches", "Mill Owner Contacts", "Cargo Insurance"],
    },
  ];

  const services = [
    {
      icon: "🚖",
      title: "Instant Booking",
      desc: "Get confirmed cabs within minutes",
    },
    {
      icon: "💰",
      title: "Best Prices",
      desc: "Guaranteed lowest fares with no hidden charges",
    },
    {
      icon: "🛡️",
      title: "Safe Rides",
      desc: "Verified drivers with 5-star ratings",
    },
    {
      icon: "⏱️",
      title: "On Time",
      desc: "95% on-time arrival record",
    },
    {
      icon: "📱",
      title: "Live Tracking",
      desc: "Real-time cab tracking via app",
    },
    {
      icon: "👨‍👩‍👧‍👦",
      title: "Family Friendly",
      desc: "Child seats and extra space available",
    },
    {
      icon: "🧳",
      title: "Luggage Space",
      desc: "Ample trunk space for your baggage",
    },
    {
      icon: "♿",
      title: "Accessible Rides",
      desc: "Wheelchair-friendly vehicles available",
    },
    {
      icon: "🌐",
      title: "City Coverage",
      desc: "Service available across entire metro area",
    },
    {
      icon: "💳",
      title: "Multiple Payments",
      desc: "Cash, card, digital wallets & corporate billing",
    },
    {
      icon: "🔄",
      title: "Easy Cancellations",
      desc: "Free cancellations up to 5 minutes after booking",
    },
    {
      icon: "📞",
      title: "24/7 Support",
      desc: "Always-available customer service",
    },
    {
      icon: "🚬",
      title: "Non-Smoking Cabs",
      desc: "Fresh, clean air in all vehicles",
    },
    {
      icon: "🐕",
      title: "Pet-Friendly",
      desc: "Travel with your furry friends",
    },
    {
      icon: "🚭",
      title: "Smoke-Free",
      desc: "All cabs are non-smoking for your comfort",
    },
    {
      icon: "🌡️",
      title: "AC Comfort",
      desc: "Climate-controlled vehicles in all seasons",
    },
    {
      icon: "📶",
      title: "Free WiFi",
      desc: "Stay connected during your ride",
    },
    {
      icon: "🔋",
      title: "Phone Charging",
      desc: "USB ports available in all premium cabs",
    },
    {
      icon: "🛣️",
      title: "Route Selection",
      desc: "Choose your preferred route via app",
    },
    {
      icon: "👔",
      title: "Executive Class",
      desc: "Premium vehicles for business travelers",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Book Taxi & Cab Services in Chh. Sambhajinagar | Best Rates
        </title>
        <meta
          name="description"
          content="Reliable taxi & cab services in Chh. Sambhajinagar (Aurangabad). Book AC cabs for airport transfers, outstation trips, local tours & temple visits at best prices."
        />
        <meta
          name="keywords"
          content="taxi in Chh. Sambhajinagar, cab services Aurangabad, book taxi online, airport taxi, outstation cabs, local taxi hire, luxury cab, budget taxi, taxi to Mumbai, taxi to Pune, taxi to Shirdi, taxi to Ajanta Ellora, reliable cab service, taxi rates, taxi booking app"
        />
        <meta
          property="og:title"
          content="Premium Taxi Services in Chh. Sambhajinagar | 24/7 Cab Booking"
        />
        <meta
          property="og:description"
          content="Book comfortable AC taxis in Chh. Sambhajinagar for all your travel needs - airport transfers, outstation trips, local tours & temple visits."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Best Taxi Services in Chh. Sambhajinagar | Instant Booking"
        />
        <meta
          name="twitter:description"
          content="Affordable & reliable taxi services in Chh. Sambhajinagar for all your travel needs. Book now for best rates on cabs to Mumbai, Pune, Shirdi & more."
        />
      </Helmet>
      <section className="routes-section">
        <div className="routes-header">
          <h2 className="routes-title">
            Chh. Sambhajinagar's Best Taxi Services
          </h2>
          <p className="routes-subtitle">
            Trusted by thousands for comfortable and reliable cab services
            across Maharashtra
          </p>
        </div>

        <div className="routes-container">
          {/* <h3 className="section-title">
          Popular Routes from Chh. Sambhajinagar
        </h3>
        <p className="section-subtitle">
          Select your destination for instant fare estimates and booking
        </p> */}
          <div className="routes-grid">
            {routes.map((route, index) => (
              <div key={index} className="route-card">
                <div className="route-content">
                  <h3 className="route-name">{route.name}</h3>
                  <div className="route-details">
                    <span className="route-type">{route.type}</span>
                    <span className="route-distance">{route.distance}</span>
                  </div>
                  <ul className="route-features">
                    {route.features.map((feature, i) => (
                      <li key={i}>✓ {feature}</li>
                    ))}
                  </ul>
                  <Link
                    to="https://wa.me/+919765007100?text=Hi,%20I'm%20interested%20in%20booking%20a%20taxi%20or%20cab.%20Please%20provide%20details."
                    target="_blank"
                  >
                    <button className="book-now-btn">
                      Book Now <span>→</span>
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="services-highlight">
          <h3 className="section-title">Why Choose Our Taxi Services?</h3>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h4>{service.title}</h4>
                <p>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="local-info">
          <h3>Chh. Sambhajinagar Local Taxi Services</h3>
          <p>Available for:</p>
          <div className="local-services">
            <span>City Rides</span>
            <span>Airport Transfers</span>
            <span>Temple Tours</span>
            <span>Business Meetings</span>
            <span>College/School Pickups</span>
            <span>Hospital Visits</span>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookRide;
